export const allDevicesWanelo = () => {
    if ($('html.no-touchevents').length > 0) {
        $('#waneloProduct').on('mouseenter', function() {
            $('#waneloProduct').off('mouseenter');
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "//cdn-saveit.wanelo.com/bookmarklet/3/save.js";
            document.getElementsByTagName("head")[0].appendChild(script);
        });
    }
    $("#waneloProduct").on("click", function(e) {
        var ms_ie = false,
            ua = window.navigator.userAgent,
            old_ie = ua.indexOf('MSIE '),
            new_ie = ua.indexOf('Trident/'),
            Edge = ua.indexOf('Edge'),
            isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
            isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
        if ((old_ie > -1) || (new_ie > -1) || (navigator.appVersion.indexOf('Edge') > -1)) ms_ie = true;
        if ((!$(isChrome)) || (!$(isSafari))) ms_ie = false;
        if (ms_ie) {
            var waneloCheck = setInterval(function() {
                if ($('#wanelo-images').length) {
                    clearInterval(waneloCheck);
                    $("#wanelo-images div:first").attr("data-src", "www").hide();
                }
            }, 100);
            e.stopPropagation;
        }
    });
};
